export default __webpack_public_path__ + "static/media/MusicalIntruments_14.61cc9b23.png";